export const BILL_RATES = '/bill_rates'
export const INVOICE_CONFIG = '/invoice-config'
export const INVOICE_ISSUES = '/invoice-issues'
export const LANDING = '/'
export const ACCOUNT = '/account'
export const PASSWORD_FORGET = '/pw-forget'
export const USERS = '/users/:keyword?'
export const USER_DETAIL = '/user/:userId'
export const SIGNIN = '/signin'
export const SHIFTS = '/shifts'
export const SHIFT_DETAIL = '/shifts/:shiftId'
export const UPCOMING_SHIFTS = '/upcoming_shifts'
export const ONGOING_SHIFTS = '/ongoing_shifts'
export const PAST_SHIFTS = '/past_shifts'
export const SINGLE_SHIFT = '/single_shift'
export const BULK_CREATE_SHIFTS = '/bulk-create-shifts'
export const USER_PAYMENTS = '/user_payments'
export const UNPAID_SHIFTS = '/unpaid_shifts'
export const INVOICES = '/payments'
export const CHARGES = '/charges'
export const LISTINGS = '/listings'
export const COMPANIES = '/companies'
export const COMPANY_DETAIL = '/companies/:companyId'
export const COMPANY_SWITCH = '/company/switch/:companyId'
export const COMPANY_GROUPS = '/company-groups'
export const COMPANY_GROUP_DETAIL = '/company-groups/:id'
export const WORKERBIZREFERRALS = '/workerbizreferrals'
export const MESSAGES2 = '/messages2'
export const POSITIONS = '/positions'
export const POSITION_DETAIL = '/positions/:positionId'
export const REQUIREMENT_DETAIL = '/requirements/:requirementId'
export const WORKER_ASSESSMENT_DETAIL =
  '/positions/:positionId/assessments/user/:userId'
export const REVIEW_ASSESSMENTS_QUEUE = '/review/assessments/queue'
export const QUEST_DEFINITIONS = '/quest_definitions'
export const REVIEW = '/review'
export const REVIEW_BLOCK_WORKER = '/review/block-worker'
export const EVENT_LOGS = '/review/event-logs'
export const USER_PERMISSIONS = '/user-permissions'
export const TIPS = '/tips'
export const POSITION_EDITOR = '/position_editor'
export const COMMANDS = '/commands'
export const SPREADSHEETS = '/spreadsheets'
export const EVERIFY_UNPROCESS_FORMS = 'e-verify-unprocessed'
export const EVERIFY_I9_REVERIFICATION_QUEUE = '/i9-reverification-queue'
export const WORKER_SUPPLY = '/worker-supply'
export const VERIFY_CREDENTIALS = '/verify-credentials'
export const INVOICE_SYNC = '/invoice-sync'
export const TIME_CLOCKS = '/time_clocks'
export const COMPUMATIC_CLOCK_PUNCHES = '/compumatic-clock-punches'
export const VMS_TIMESHEET_UPLOAD = '/vms-timesheet-upload'
export const PLAYGROUND = '/playground'
export const PLAYGROUND_COACH_SKILLS_COLLECTION =
  '/playground/coach/skills-collection'
export const PLAYGROUND_COACH_ASSESSMENTS = '/playground/coach/assessments'
export const PLAYGROUND_HIGHNOTE_NOTIFICATION_TASKS =
  '/playground/highnote/notification-tasks'
export const PLAYGROUND_HTTP_SERVICES = '/playground/http-services'
export const DAYFORCE = '/dayforce'
export const DAYFORCE_BOOKINGS = '/dayforce/bookings'
export const DAYFORCE_JOB_DETAIL = '/dayforce/jobs/:agencyId/:jobId'
export const DAYFORCE_WEBHOOKS = '/dayforce/webhooks'
export const DAYFORCE_WEBHOOK_DETAIL = '/dayforce/webhooks/:webhookId'
export const DAYFORCE_JOBS_ISSUES = '/dayforce/jobs-issues'
export const VNDLY = '/vndly'
export const VNDLY_ISSUES = '/vndly/issues'
export const VNDLY_COLUMBIA_TIMESHEET = '/vndly/columbia/timesheet'
export const INDEED_FLEX = '/indeed-flex'
export const INDEED_FLEX_COMPANIES = '/indeed-flex/companies'
export const INDEED_FLEX_SHIFT_ISSUES = '/indeed-flex/shift-issues'
export const INDEED_FLEX_JOB_SHIFTS = '/indeed-flex/job-shifts'
export const INDEED_FLEX_OTP = '/indeed-flex/otp'
export const FIELDGLASS = '/fieldglass'
export const FIELDGLASS_SHIFT_ISSUES = '/fieldglass/shift-issues'
export const FIELDGLASS_JOB_POSTING = '/fieldglass/job-posting'
export const JET = '/jet'
export const JET_CALL_REPORT_SYNC_STATUS = '/jet/call-report-sync-status'
export const JET_ALERTS = '/jet/alerts'
export const JET_ASSIGNMENTS = '/jet/assignments'
// Wage Rules pages
export const WAGE_JURISDICTIONS = '/wages/jurisdictions'
export const WAGE_JURISDICTION_DETAIL = '/wages/jurisdictions/:jurisdictionId'
export const WAGE_RULES = '/wages/rules'
export const WAGE_RULE_DETAIL = '/wages/rules/:ruleId'
// W2 admin pages
export const W2_WORK_STATUS = '/w2/work-status'
export const W2_PENDING_PAYMENTS = '/w2/pending-payments'
export const W2_ITEMS_IN_REVIEW = '/w2/items-in-review'
export const HIGHNOTE_TOPUP = '/playground/highnote/topup'
